var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 74,
    viewBox: "0 0 72 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13L36 33.5L72 13V54L36 74L0 54V13Z",
    fill: "#1355FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.4518L28.0916 -2.93255e-05L27.5148 9.4163L15.2114 16.0965L7 11.4518Z",
    fill: "#FFCE73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.4518L38.0916 5.99997L37.5148 15.4163L25.2114 22.0965L17 17.4518Z",
    fill: "#FFCE73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.4518L48.0916 12L47.5148 21.4163L35.2114 28.0965L27 23.4518Z",
    fill: "#FFCE73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 54V13L36 33.5V74L0 54Z",
    fill: "#BDCFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockitLogo);
export default __webpack_public_path__ + "static/media/stockit-logo.64073aad3c0e7c3c510dfd9441ba798e.svg";
export { ForwardRef as ReactComponent };